import { render, staticRenderFns } from "./TransactionsSuspendedNoticeModal.vue?vue&type=template&id=c0f2779c&scoped=true"
import script from "./TransactionsSuspendedNoticeModal.vue?vue&type=script&lang=js"
export * from "./TransactionsSuspendedNoticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f2779c",
  null
  
)

export default component.exports